module.exports = __webpack_public_path__ + "public/Icons/delete.svg?b6e23ce8";